import { catalogEnvironmentError, isCatalogEnvironment } from '@/pages/QuickCreate/catalogEnvironment';
import { handleResponse, makePost } from '@/redux/api/helpers';
import {
    QuickCreateCatalog,
    QuickCreateCatalogSuccessPayload,
} from '@/redux/modules/quickCreate/catalog/quickCreateCatalog.types';

type PostQuickCreateCatalogParams = {
    authToken: string;
    catalog: QuickCreateCatalog;
    deployment: string;
};

export type PostQuickCreateCatalogResponse =
    | {
          error: true;
          payload: string;
      }
    | {
          error: false;
          payload: QuickCreateCatalogSuccessPayload;
      };

export const postQuickCreateCatalog = ({ authToken, catalog, deployment }: PostQuickCreateCatalogParams) =>
    new Promise<PostQuickCreateCatalogResponse>((resolve, reject) => {
        if (!isCatalogEnvironment(deployment)) {
            reject(catalogEnvironmentError);
            return;
        }
        const request = makePost({
            apiPath: 'createtestauction',
            authToken,
            deployment,
            path: '<SUPPORT-API>',
        });

        request.send(catalog);
        request.end((err, response) => handleResponse({ err, reject, resolve, response }));
    });
